import { put, takeLatest } from 'redux-saga/effects';
import handleException from '../services/handleException';
import { getSummary } from '../utils/headerSummary';

function* getHeaderSummaryHandle() {
    try {
        const json = yield getSummary()
        if (json.data.code === 10001) {
            yield put({ type: 'GET_HEADER_SUMMARY_SUCCESS', payload: json })
        } else {

            yield put({ type: 'GET_HEADER_SUMMARY_SHIPPER_NOT_FOUND' })
            yield put({ type: 'RESET_SUMMARY_HEADER' })
            handleException(json)
        }
    } catch (error) {
        yield put({ type: 'GET_HEADER_SUMMARY_ERROR', payload: error })
        yield put({ type: 'RESET_SUMMARY_HEADER', payload: error })
        handleException(error)
    }
}
export function* getHeaderSummary() {
    yield takeLatest('ON_GET_HEADER_SUMMARY', getHeaderSummaryHandle)
}



// WEBPACK FOOTER //
// ./src/sagas/headerSaga.js